<template>
	<div class="wrapper">
		<headerTag />
		<div class="tsBanner">
			<img src="../../assets/images/user/tsBanner.png" alt="" class="tsBanner_img"/>
			<img src="../../assets/images/user/tsBanner_txt.png" alt="" class="tsBanner_txt" />
		</div>
		<div class="twDiv twDiv3">
			<p>问题类型</p>
			<select class="twSel" ref="type">
				<option value="">-请选择-</option>
				<option value="1">公司注册</option>
		        <option value="2">代理记账</option>
		        <option value="3">企业变更</option>
		        <option value="4">地址异常处理</option>
		        <option value="5">开设基本户</option>
		        <option value="6">公司注销</option>
		        <option value="7">税务筹划</option>
		        <option value="8">发票申领</option>
		        <option value="9">税务解非</option>
		        <option value="10">年度汇算清缴</option>
		        <option value="11">年度工商年报</option>
		        <option value="12">食品经营许可证</option>
		        <option value="13">财税咨询</option>
		        <option value="14">香港公司注册</option>
		        <option value="15">香港公司注销</option>
			  	<option value="16">开设一般户</option> 
			  	<option value="17">刻章备案</option>     
			  	<option value="18">社保开户</option>     
			  	<option value="19">开设公积金账户</option>     
			  	<option value="20">定制代记账方案</option>     
			  	<option value="21">旧账梳理</option>     
			  	<option value="22">年报异常解非</option>     
			  	<option value="23">开票咨询</option>     
			  	<option value="24">外勤上门服务</option>     
			  	<option value="25">电商客服外包</option>     
			  	<option value="26">劳务派遣许可证</option>     
			  	<option value="27">道路运输许可证</option>     
			  	<option value="28">游戏出版运营备案</option>  
			  	<option value="29">ODI境外投资</option>
			</select>
		</div> 
		<div class="twDiv twDiv3">
			<p>问题标题</p>
			<textarea class="twTxt" ref="title" placeholder="请简单描述您的问题（最多50字）" autocomplete="off" maxlength="50">
				
			</textarea>
		</div> 
		<div class="twDiv twDiv3" style="margin-bottom: 0;">
			<p>详情描述</p>
			<textarea class="twTxt" ref="describe" placeholder="请简单描述您的问题（最多500字）" maxlength="500"
	                  autocomplete="off">
				
			</textarea>
		</div>
		<div class="twDiv twDiv3">
			<p class="userIn1 userIn2" style="margin-bottom: 0; margin-right: 0; width: 60%; float: left; padding: 0;">
				<input type="text" placeholder="请输入验证码" maxlength="4" style="width: 100%; height: 2rem; margin-top: 0.6rem; line-height: 2rem;" autocomplete="off" ref="picCode" onKeyUp="value=value.replace(/[\W]/g,'')" />
			</p>
			<canvas id="canvas" class="codeImg" @click="imgCode" style="height: 2.4rem; margin-top: 0.4rem;"></canvas>
		</div>
		<button class="userBtn1" @click="addQuestion" :disabled="isDisable">提交</button>
		<footerTag />
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
    import {VidateUtil} from '../../assets/js/validate.js' 
    import { Dialog } from 'vant'
    
    export default {
    	name: 'wyTiwen',
    	props: {
        
    	},
    	data:function(){
			return {
				isDisable:false
			}
		},
		methods:{
			getUserInfo(){
				this.axios({
					method: 'POST',
					url:'/user/getUserName',
				}).then((res)=>{
					if(res.data.obj == null || res.data.obj == ''){
						// 用户未登录
						let currPath=window.location.href;
				  		window.location.href='/login?targetUrl='+currPath;
					}else{
						
					}
				}).catch((err)=>{
					
				})
			},
			imgCode(){
				this.axios({
				    method: 'POST',
				    url:'/sendCode',
				}).then((res)=>{
					let data = res.data;
					VidateUtil.drawPic(data);
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			addQuestion(){
				let type=this.$refs.type.value;
				let title=this.$refs.title.value;
				let describe=this.$refs.describe.value;
				let code=this.$refs.picCode.value;
				if (type == "") {
			        this.$message.error({message: '请选择问题分类'});
			        return;
			    }
			    if (title == "" || title == null) {
			        this.$message.error({message: '问题标题不能为空'});
			        return;
			    }
			    if(title.length > 50){
			        this.$message.error({message: '问题标题不能超过50个字符'});
			        return;
			    }
			    if(describe == "" || describe == null) {
			        this.$message.error({message: '详情描述不能为空'});
			        return;
			    }
			    if(describe.length > 500) {
			        this.$message.error({message: '详情描述不能超过500个字符'});
			        return;
			    }
			    if (code == "") {
			        this.$message.error({message: '验证码不能为空'});
			        return;
			    }
			    if (code.length != 4) {
			        this.$message.error({message: '验证码输入有误'});
			        return;
			    }
				//按钮不可点击
				this.isDisable=true; 
				this.axios({
					method: 'POST',
					url:'/feedback/saveAskInfo',
					params:{
						type:type,
						title:title,
						describe:describe,
						picCode:code
					},
				}).then((res)=>{
						this.isDisable=false; //按钮可点击
						this.imgCode();//切换图片验证码
						if(res.data.code == 1000){
							//成功(返回到我的提问列表)
							Dialog.alert({
							  message: '提问成功'
							}).then(() => {
							  	this.$router.push({ name:'mineTiwen' });
							});
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
			  			}else if(res.data.code == 1002){
							//置空
							this.$refs.type.value=""; 
							this.$refs.title.value=""; 
							this.$refs.describe.value=""; 
							this.$refs.picCode.value=""; 
							this.$message.error({message: res.data.message});
						}else if(res.data.code == 3100 || res.data.code == 3101){
							this.$refs.picCode.value=""; //置空
							this.$message.error({message: res.data.message});
						}else if(res.data.code == 4102){
							this.$refs.picCode.value=""; //置空
							this.$message.error({message: res.data.message});
						}else if(res.data.code == 4102){
							this.$refs.picCode.value=""; //置空
							this.$message.error({message: res.data.message});
						}else{
							this.$message.error({message: '网络异常，请稍后重试'});
						}
				}).catch((err)=>{
					this.imgCode();//切换图片验证码
					this.isDisable=false; //按钮可点击
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			}
		},
    	components: {
    		headerTag,
    		footerTag
    	},
    	created() {
			this.imgCode();
			this.getUserInfo();
		}
    }
</script>


